module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['ThePageExternal', _vm.className]
  }, [_c('div', {
    staticClass: "ThePageExternal__header"
  }, [_c('TheLogo'), _vm._v(" "), _c('div', {
    staticClass: "ThePageExternal__title"
  }, [_vm._v("\n            " + _vm._s(_vm.translate(_vm.title)) + "\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "ThePageExternal__content"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22f01090"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/ThePageExternal.vue
// module id = 486
// module chunks = 1